import axios from "axios";
import { request, ResponseData } from "../instance";
import { UserInfo, UserIntegral } from "./userTypes";

const headers = { "Content-Type": "application/json" };

export const fetchUserInfo = async (): Promise<ResponseData<UserInfo>> => {
  const resp = await request("user/info");
  return resp;
};

// export const userLogout = async (): Promise<ResponseData<UserInfo>> => {
//   const resp = await request("user/logout");
//   return resp;
// };

export const userLogout = async (
  data: UserInfo | undefined
): Promise<ResponseData<UserInfo>> => {
  const resp = await request("user/logout", {
    method: "PUT",
    data,
    headers,
  });
  return resp;
};

export const userLogin = async (userInfo: any): Promise<ResponseData> => {
  let requestUrl = window.origin + "/api/user/login";
  const resp = await axios({
    method: "post",
    url: requestUrl,
    data: userInfo,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return resp;
};

export const userRegister = async (userInfo: any): Promise<ResponseData> => {
  let requestUrl = window.origin + "/api/user/register";
  const resp = await axios({
    method: "post",
    url: requestUrl,
    data: userInfo,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return resp;
};

export const userInfoModify = async (userInfo: any): Promise<ResponseData> => {
  let requestUrl = window.origin + "/api/user/info";
  const resp = await axios({
    method: "put",
    url: requestUrl,
    data: userInfo,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return resp;
};

export const userPasswordModify = async (
  userInfo: any
): Promise<ResponseData> => {
  let requestUrl = window.origin + "/api/user/password";
  const resp = await axios({
    method: "put",
    url: requestUrl,
    data: userInfo,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return resp;
};

export const userGetVerifyCode = async (data: {
  mobile: string | undefined;
  scenes: string;
}): Promise<ResponseData> => {
  let requestUrl = window.origin + "/api/user/verify/code";
  try {
    const resp = await axios({
      method: "post",
      url: requestUrl,
      data,
      headers: { "Content-Type": "multipart/form-data" },
    });
    return resp;
  } catch (err) {
    return {
      data: {
        code: 500,
        msg: "服务器错误",
      },
    };
  }
};

export const asyncSignUp = async (data: {
  mobile: string | undefined;
  verifyCode: string;
}): Promise<ResponseData> => {
  let requestUrl = window.origin + "/api/user/signUp";
  const resp = await axios({
    method: "post",
    url: requestUrl,
    data,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return resp;
};

export const fetchUserIntegral = async (): Promise<
  ResponseData<UserIntegral>
> => {
  const resp = await request("user/integral/info");
  return resp;
};

export const userCheckIn = async (): Promise<ResponseData> => {
  let requestUrl = window.origin + "/api/user/integral/checkIn";
  const resp = await axios({
    method: "post",
    url: requestUrl,
    // data: userInfo,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return resp;
};

export const updateLeftConsoleSettings = async (
  data: any
): Promise<ResponseData> => {
  let requestUrl = window.origin + "/api/user/config/update";
  const resp = await request(requestUrl, {
    method: "POST",
    data,
    headers,
  });

  return resp;
};
